import React from 'react';
import { RecallsAppModel } from '../../typings/general';
import CarHeader from './car-header';
import { styled } from '@vw-marketing/us-components';
import RecallSection from './recall-section';

export const ResultSectionContainer: any = styled.div`
  padding-top: 40px;
`;

interface ResultsSectionProps {
  recallData?: RecallsAppModel;
}
const ResultsSection = ({ recallData }: ResultsSectionProps): JSX.Element => {
  if (!recallData) return <></>;
  const serviceDescription =
    'Service campaigns shown may be available for a limited time only. Please contact your authorized VW dealer for additional information.';
  const serviceLabel =
    recallData.serviceRecalls && recallData.serviceRecalls?.length > 0
      ? 'Other Service Campaign'
      : 'Other Service Campaigns';
  const recallLabel =
    recallData.safetyRecalls && recallData.safetyRecalls?.length > 0
      ? 'Recall'
      : 'Recalls';

  return (
    <ResultSectionContainer data-testid="results-section">
      <CarHeader {...recallData} showPrint={recallData.isRecallsAvailable} />
      <RecallSection
        recalls={recallData.safetyRecalls}
        label={recallLabel}
        noFoundLabel={'Recalls'}
      />
      <RecallSection
        recalls={recallData.serviceRecalls}
        label={serviceLabel}
        noFoundLabel={'Service Campaigns'}
        serviceDescription={serviceDescription}
      />
    </ResultSectionContainer>
  );
};

export default ResultsSection;
